import React from "react";
import { colors } from '../../../theme/colors';
import { Typography, Box, Chip, Button } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CodeIcon from "@mui/icons-material/Code";
import logo from "../../../assets/Images/element-wordmark-dark.svg";
import { AssessmentHeaderWrapper } from "./style";

const AssessmentHeader = ({
  currentQ,
  globalTimeLeft,
  formatTime,
  localVideoRef,
  onOpenGuidelines,
}) => {
  const timeColor = globalTimeLeft <= 300 ? "#e53935" : "#1d2939";

  return (
    <AssessmentHeaderWrapper>
      <Box className="header-left">
        <img src={logo} alt="Berlin" className="header-logo" />
        <Typography className="header-title">Technical Assessment</Typography>
      </Box>

      <Box className="header-center">
        <Box className="webcam-preview">
          <video ref={localVideoRef} autoPlay muted playsInline />
        </Box>

        {currentQ?.type && (
          <Chip
            icon={<CodeIcon sx={{ fontSize: 16, color: colors.primary }} />}
            label={currentQ.type}
            size="small"
            variant="outlined"
            sx={{
              borderColor: colors.primary,
              color: colors.primary,
              fontWeight: 600,
              fontSize: "13px",
            }}
          />
        )}

        <Button
          variant="outlined"
          size="small"
          startIcon={<MenuBookIcon />}
          onClick={onOpenGuidelines}
          sx={{
            borderColor: "#d0d5dd",
            color: "#344054",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "8px",
            "&:hover": { borderColor: colors.primary, color: colors.primary },
          }}
        >
          Guidelines
        </Button>
      </Box>

      <Box className="header-right">
        <Typography className="timer-display" sx={{ color: timeColor }}>
          <AccessTimeIcon sx={{ fontSize: 20, color: timeColor }} />
          Time Left: {formatTime(globalTimeLeft)}
        </Typography>
      </Box>
    </AssessmentHeaderWrapper>
  );
};

export default AssessmentHeader;
